module.exports = __webpack_public_path__ + "img/panelView_blackBg_1_3.bc4cc428.png";